import { profileMenus } from "../../assets/data/application/profile-menus";
import Icon from "../../assets/icons";
import { Dialog } from "@headlessui/react";
// import Image from "next/image";
// import Link from "next/link";
import { Link } from "react-router-dom";
import { useState } from "react";
import { AiOutlineCloseCircle, AiOutlineMenu } from "react-icons/ai";
import ProfileMenu from "./ProfileMenu";
import { Popover } from "@radix-ui/themes";



const MobileNavBar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <Popover.Root>
        {/* Top bar */}
        <div className="h-16 w-full flex justify-between px-4 sm:px-10">
          <div  className="flex items-center">
            <span className="sr-only">Viliyo</span>
            <img
              src={Icon.logo}
              alt="Viliyo Logo"
              className="h-6 w-auto object-contain"
            />
          </div>

          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <AiOutlineMenu className="h-6 w-6" />
          </button>
        </div>

        {/* Mobile menu dialog */}
        <Dialog
          className="relative z-50"
          open={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
        >
          <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

          <div className="fixed inset-0 flex items-center justify-center p-4">
            <Dialog.Panel className="w-full h-full fixed left-0 bg-app-purple-100">
              {/* Pass closeMenu to ProfileMenu */}
              <ProfileMenu
                menus={profileMenus}
                onClose={() => setMobileMenuOpen(false)}
              />

              {/* Close button */}
              <button
                className="absolute top-5 right-10"
                onClick={() => setMobileMenuOpen(false)}
              >
                <AiOutlineCloseCircle className="h-12 w-12" />
              </button>
            </Dialog.Panel>
          </div>
        </Dialog>
      </Popover.Root>
    </>
  );
};


export default MobileNavBar